import { Tag } from 'lucide-react';

import { TagInput } from '@/components/ui/TagInput';

import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'tags',
  renderInput: ({ field, value, onChange }) => {
    const suggestions = (field.options ?? []).map((o) => o.label);
    const tags = Array.isArray(value) ? (value as string[]) : [];
    return (
      <TagInput
        value={tags}
        onChange={onChange}
        suggestions={suggestions}
        allowCustom={suggestions.length === 0}
      />
    );
  },
  renderCell: (_field, value) => {
    if (!Array.isArray(value) || value.length === 0) return '—';
    const tags = value as string[];
    const shown = tags.slice(0, 3);
    const rest = tags.length - 3;
    return (
      <div className="flex items-center gap-1 flex-wrap">
        <Tag className="h-3.5 w-3.5 flex-shrink-0 text-text-muted" />
        {shown.map((tag) => (
          <span
            key={tag}
            className="rounded-full bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-700"
          >
            {tag}
          </span>
        ))}
        {rest > 0 && <span className="text-xs text-text-tertiary">+{rest}</span>}
      </div>
    );
  },
  validate: (value, field) => {
    if (!Array.isArray(value) || value.length === 0) {
      return field.isRequired ? 'Dodaj przynajmniej jeden tag' : null;
    }
    return null;
  },
  defaultValue: [],
});
